import { useGeocodeQuery } from '@graphql/platform';

export function useEligibleForDisposalZIP(zip?: string): boolean {
  const { data } = useGeocodeQuery({
    variables: { zip: zip ?? '' },
    skip: !zip,
  });
  return !!data?.geocode?.eligibleForDisposal;
}
